import { SVGProps } from 'react'

export const YoutubeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_2027_3168)">
      <path
        d="M19.6016 5.1541C19.4885 4.72861 19.2657 4.34029 18.9554 4.02798C18.6451 3.71568 18.2582 3.49035 17.8334 3.37456C16.2698 2.9541 10.0198 2.9541 10.0198 2.9541C10.0198 2.9541 3.76978 2.9541 2.20614 3.37456C1.78138 3.49035 1.39449 3.71568 1.08418 4.02798C0.773872 4.34029 0.55103 4.72861 0.437957 5.1541C0.0197754 6.72456 0.0197754 9.99956 0.0197754 9.99956C0.0197754 9.99956 0.0197754 13.2746 0.437957 14.845C0.55103 15.2705 0.773872 15.6588 1.08418 15.9711C1.39449 16.2834 1.78138 16.5088 2.20614 16.6246C3.76978 17.045 10.0198 17.045 10.0198 17.045C10.0198 17.045 16.2698 17.045 17.8334 16.6246C18.2582 16.5088 18.6451 16.2834 18.9554 15.9711C19.2657 15.6588 19.4885 15.2705 19.6016 14.845C20.0198 13.2746 20.0198 9.99956 20.0198 9.99956C20.0198 9.99956 20.0198 6.72456 19.6016 5.1541Z"
        fill="#FF0302"
      />
      <path
        d="M7.97449 12.9741V7.02637L13.2018 10.0002L7.97449 12.9741Z"
        fill="#FEFEFE"
      />
    </g>
    <defs>
      <clipPath id="clip0_2027_3168">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
